// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1mpKQ","validationTips":"StatementDescriptor_validationTips__8IDcc"};